var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('static-tabs-wallet',{attrs:{"active":"groups"}}),_vm._v(" "),_c('registry-groups')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }